import React from "react";
import {
  TextField,
  Button,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Link } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { authAction } from "../../slices/authSlice";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { LoadingButton } from "@mui/lab";
import SendIcon from '@mui/icons-material/Send';

const validationSchema = yup.object().shape({
  email: yup.string().email("Invalid email address").required("Email is required"),
});

type FormValues = {
  email: string;
};

const ForgotPassword: React.FC = () => {
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const { loading } = useAppSelector(state => state.auth);
  const { control, handleSubmit, formState: { errors } } = useForm<FormValues>({
    resolver: yupResolver(validationSchema),
    mode: 'onChange',
  });

  const handleForgotPassword = async (data: FormValues) => {
    try {
      const actionResult = await dispatch(authAction({
        method: 'post',
        data: data,
        actionType: 'forgot-password',
      }));
      if (authAction.fulfilled.match(actionResult)) {
        console.log('Password reset link sent successfully');
      }
    } catch (error) {
      console.error('Forgot password failed:', error);
    }
  };

  return (
    <>
      <Typography component="h1" variant="h5" gutterBottom>
        Forgot Password
      </Typography>
      <form onSubmit={handleSubmit(handleForgotPassword)} autoComplete="off" style={{ width: '100%' }}>
        <Controller
          name="email"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <TextField
              {...field}
              variant="standard"
              margin="normal"
              fullWidth
              id="email"
              label="Email"
              type="text"
              autoFocus
              error={!!errors.email}
              helperText={errors.email?.message}
            />
          )}
        />
        {
          loading ?
          <LoadingButton
            fullWidth
            endIcon={<SendIcon />}
            loading={loading}
            loadingPosition="end"
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            Loading
          </LoadingButton>
          :
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            Submit
          </Button>
        }
      </form>
      <Link to="/login" style={{ textDecoration: 'none' }}>
        <Typography sx={{ fontSize: '12px', my: 3, color: theme.palette.primary.main }}>
          Back to Login
        </Typography>
      </Link>
    </>
  );
};

export default ForgotPassword;
